module.exports = __webpack_public_path__ + "img/u235.22d03fb6.svg";